import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from "classnames";
import { numberWithDotsAndComma } from '~utils/numberWithDotsAndComma';
import { CSIcon } from '~icons/rankingList/CSIcon';
import CSCoin from '~icons/balance/CS_Coin.svg';
import { PaintedCircle } from "~atoms/WhiteCircle/PaintedCircle";
import { useIsDesktop } from "~hooks";
import { formatLargeNumber } from "~utils/formatLargeNumber";
import { useStyles } from './UserCardCartoonHeader.styles';
export var UserCardCartoonHeader = function (_a) {
    var name = _a.name, groupName = _a.groupName, balance = _a.balance, level = _a.level, _b = _a.stars, stars = _b === void 0 ? 0 : _b, background = _a.background, extraClass = _a.extraClass, isCardVisible = _a.isCardVisible, isGlobalRanking = _a.isGlobalRanking, showJoinGameModal = _a.showJoinGameModal;
    var t = useTranslation('tip-game').t;
    var classes = useStyles();
    var isDesktop = useIsDesktop();
    var isJoinGameButton = !isGlobalRanking && !level;
    var onCardHeaderClick = function () {
        if (isJoinGameButton && showJoinGameModal) {
            showJoinGameModal();
        }
    };
    return (React.createElement("div", { role: "button", tabIndex: 0, className: classNames(classes.wrapper, !isDesktop && classes.positionFixed, extraClass), style: { background: background }, onClick: onCardHeaderClick }, isCardVisible ? (React.createElement("div", { className: classNames(classes.userCardIsVisible, groupName && classes.noPaddingRight) },
        React.createElement("span", { className: classNames(classes.name, groupName && classes.halfWidth) }, name),
        groupName ? (React.createElement("span", { className: classes.groupName }, groupName)) : (React.createElement(PaintedCircle, { paintedCount: stars })))) : (React.createElement("div", { className: classes.userCardIsHidden },
        React.createElement("span", { className: classes.name }, name),
        isGlobalRanking ? (React.createElement("span", { className: classes.level }, level ? "".concat(t('rank'), " ").concat(level) : '')) : (React.createElement("span", { className: classes.level },
            " ",
            level ? "".concat(t('level'), " ").concat(level) : t('join_the_game'))),
        balance || balance === 0 ? (React.createElement("span", { className: classes.balance },
            isGlobalRanking ? formatLargeNumber(balance) : numberWithDotsAndComma(balance),
            isGlobalRanking ? (React.createElement("img", { src: CSCoin, alt: 'coin' })) : (React.createElement(CSIcon, { size: "sm", color: '#6CFF00' })))) : null))));
};
